import axios from "axios";

/**
 * Prompts the user with a confirmation dialog to delete a specific link.
 * If the user confirms, the provided delete function is executed for the given link ID.
 *
 * @param {string} id - The unique identifier of the link to be deleted.
 * @param {function} swal - A function to display a confirmation dialog. Typically from a library like SweetAlert.
 * @param {function} deleteLinkFn - The function to execute the deletion of the link.
 * @return {Promise<void>} Resolves when the confirmation dialog is processed and, if confirmed, the deletion function is executed.
 */
export async function confirmAndDeleteLink(id, swal, deleteLinkFn) {
    const result = await swal({
        title: 'Are you sure?',
        text: "The link will be removed.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
        deleteLinkFn(id);
    }
}

/**
 * Deletes a specified link by its ID from the server and updates the local list of links.
 *
 * @param {number|string} id - The unique identifier of the link to be deleted.
 * @param {Array} dataLinks - The current list of link objects.
 * @param {Function} setDataLinks - A function to update the local list of links after deletion.
 * @return {Promise<void>} A promise that resolves when the delete operation is complete.
 */
export async function deleteLink(id, dataLinks, setDataLinks) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const token = sessionStorage.getItem("token");
    if (!token) {
        console.error("No se encontró el token en sessionStorage");
        return;
    }
    try {
        const response = await axios.delete(`${apiUrl}/links/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (response.status === 200) {
            setDataLinks(dataLinks.filter((link) => link.id_links !== id));
        } else {
            console.error("Error al eliminar el link");
        }
    } catch (error) {
        console.error("Error al eliminar el link:", error);
    }
}
